import ProjectsCard from "../components/ProjectsCard";
import Title from "../components/Title";

function Projects() {
  return (
    <section className="my-24 lg:my-48" id="projects">
      <div className="el-container-lg ">
        <Title title="Projects" />
        <p className="mt-4">Here are some of the projects I have worked on.</p>
        <div className="grid grid-cols-[repeat(auto-fit,_minmax(22rem,_1fr))]  gap-5 mt-12">
          <ProjectsCard
            text=" A fully responsive weather app made with react and tailwind css. some of the features:
          hourly weather, air quality, sunrise and sunset, weather prediction for upcoming days, air
          pressure and more."
            title="Weather app"
            href="https://github.com/dev-parsa/react-weather-app"
            href2="https://pacoweather.netlify.app"
          />
          <ProjectsCard
            text=" A versatile Metronome app made with react and framer motion. some of the features: various time signatures, cutomizable tunes, track your time practiced, light and dark mode"
            title="Metronome"
            href="https://github.com/dev-parsa/React-Metronome"
          />
          <ProjectsCard
            text=" Simulating round Robin CPU scheduling algorithm using vanilla javascript. This app has a fully functional interface for adding processes, quantom and being able to see the gantt visually."
            title="Round Robin Algorithm"
            href="https://github.com/dev-parsa/Round-Robin-Algorithm"
          />
          <ProjectsCard
            text=" This app is made with vanilla javascript. I had so much fun making this app. You can create awesome beats with it, similar to garageBand app in iphone."
            title="Beatmaker"
            href="https://github.com/dev-parsa/beat-maker-web-app"
          />
        </div>
      </div>
    </section>
  );
}

export default Projects;
